<template>
  <div class="min-h-screen bg-black text-white font-sans">
    <nav class="flex justify-between items-center p-6 border-b border-gray-800">
      <h1 class="text-2xl font-bold">getreferral</h1>
      <a href="/login" class="text-black rounded-md font-bold text-sm bg-white p-2">Login/Signup</a>
    </nav>

    <header class="text-center px-1 py-8">
      <h2 class="text-4xl font-bold mb-4">An Open & Transparent Referral Marketplace</h2>
      <p class="text-lg max-w-2xl mx-auto leading-loose mb-2">
        Get referral from
        <strong class="text-3xl text-green-500 text-shadow-2xs">Verified</strong>
        employees.
        <br>
        Earn credits for every successful referral.
      </p>
    <a href="/login" class="text-white rounded-md font-semibold text-lg bg-blue-600 p-2 m-2">Get Started</a>
    <h1 class="text-lg text-white max-w-2xl mx-auto font-semibold mt-2">First to verify from a company? 
      <br>  <strong class="text-2xl text-shadow-2xs">Get 100 bonus credits.</strong></h1>
    </header>

    <section class="py-8 px-2">
      <div class="grid flex items-center justify-center md:grid-cols-1 gap-10">
        <div>
          <h3 class="text-3xl text-center font-bold mb-2">How It Works</h3>
          <div class="flex justify-center">
          <ul class="text-center list-none list-inside space-y-2 text-white font-medium text-sm">
            <li>Sign up and verify work mail in less than a minute.</li>
            <li>Don't worry we do not store your work mail.</li>
            <li>View referral requests for your company.</li>
            <li>Accept, refer and earn credits for each one.</li>
          </ul>
          </div>
        </div>
        <!-- <div>
          <h3 class="text-3xl text-center font-bold mb-2">Why Join?</h3>
          <p class="text-white text-center text-base font-medium">
            <strong class="text-2xl text-blue-600">
            Takes less than a minute.
            </strong><br>
            Start referring, earn credits, and help others land their dream jobs.
            Lets grow the referral community.
          </p>          
        </div> -->
      </div>
      <p class="mt-10 rounded-3xl bg-gray-800 text-xl pt-10 py-8 px-8 text-white text-center font-bold break-normal">
        You might be thinking What's in it for us? For now, nothing. The goal is to solve for a problem which I faced.
        <strong class="text-blue-600 text-3xl font-semibold">At least thats what we think we are doing 😅!</strong>
        In the future, <strong class="text-red-600 text-3xl font-semibold">if</strong> we do grow big enough we might take a small cut from the referral reward — but that’s far off.
        </p>
    </section>
    <footer class="text-center text-gray-500 py-8 text-sm border-t border-gray-800">
      &copy; 2025 getreferral Built with ❤️ for fairness and transperacy.
    </footer>
  </div>
</template>


<style>  
</style>